import script from "./RefundPolicyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundPolicyPage.vue?vue&type=script&setup=true&lang=js"

import "./RefundPolicyPage.vue?vue&type=style&index=0&id=221b5300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221b5300"]])

export default __exports__